import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ROUTE_HOME, ROUTE_LOGIN_EMAIL } from '../../../../constants/Routes';
import { login, resetDeferLogin } from '../../../../actions/authenticationActions';
import PasswordUpdated from './PasswordUpdated';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_PASSWORD,
	EVT_RECOVER_PASSWORD_LOGIN,
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_NAME_PASSWORD_RECOVERY,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_ELEMENT_STYLE_PRIMARY,
} from '../../../../constants/SnowplowEvents';
import { ONBOARDING_UPDATED_PASSWORD_CTA } from '../../../../constants/Copy';

@connect(
	({ authentication }) => ({
		deferredLogin: authentication.deferredLogin,
	}),
	{ login, resetDeferLogin }
)
export default class PasswordUpdatedContainer extends Component {
	state = { loading: false };

	static propTypes = {
		history: PropTypes.object.isRequired,
		login: PropTypes.func.isRequired,
		resetDeferLogin: PropTypes.func.isRequired,
	};

	handleClick = async () => {
		await initiateTrackStructEvent({
			category: EVT_PASSWORD,
			action: EVT_RECOVER_PASSWORD_LOGIN,
			label: ONBOARDING_UPDATED_PASSWORD_CTA,

			rtlElementContext: {
				elementInteraction: EVT_ELEMENT_INTERACTION,
				elementGroup: EVT_ELEMENT_NAME_PASSWORD_RECOVERY,
				elementType: EVT_ELEMENT_TYPE_BUTTON,
				elementName: EVT_PASSWORD,
				elementLabel: ONBOARDING_UPDATED_PASSWORD_CTA,
				elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
			},
		});
		const { history } = this.props;
		history.push({ pathname: ROUTE_LOGIN_EMAIL });
	};

	/**
	 * The deferred login stores the username/password within the session
	 * until the user has seen the updated message.
	 */
	deferLogin = () => {
		const { deferredLogin, resetDeferLogin, login, history } = this.props;
		resetDeferLogin();
		login({
			email: deferredLogin.email,
			password: deferredLogin.password,
		}).then(() => {
			if (deferredLogin.returnUrl) {
				history.push(deferredLogin.returnUrl.replace(__HOST__, ''));
			} else {
				history.push(ROUTE_HOME);
			}
		});
	};

	render() {
		return <PasswordUpdated onClick={this.handleClick} loading={this.state.loading} />;
	}
}
